<template>
  <!-- 站点管理 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head topAn">
        <div>
          <el-button
            type="primary"
            size="mini"
            plain
            @click="addId('menu', 0, 0, 0)"
          >
            <i class="el-icon-plus"></i>添加父级
          </el-button>
        </div>
        <!-- 筛选 -->
        <div class="screening_box">
          <el-input
            v-model="siteName"
            placeholder="请输入名称"
            clearable
            @change="search"
          ></el-input>
          <!-- <el-input v-model="siteId" placeholder="请输入siteId或taskId" @change='search'></el-input> -->
          <el-select
            v-model="siteType"
            filterable
            placeholder="请选择id类型"
            @change="selectType"
          >
            <el-option label="全部" value="" />
            <el-option label="taskID" value="0" />
            <el-option label="siteID" value="1" />
          </el-select>
        </div>
      </div>
      <!-- 列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
        >
          <el-table-column label="类型">
            <template slot-scope="scope">
              <span style="color:#67C23A" v-if="scope.row.siteType == 0"
                >taskID</span
              >
              <span style="color:#E6A23C" v-if="scope.row.siteType == 1"
                >siteID</span
              >
            </template>
          </el-table-column>
          <!-- <el-table-column
                        prop="siteId"
                        label="父级id">
                    </el-table-column> -->
          <el-table-column prop="siteName" label="名称"> </el-table-column>
          <el-table-column width="70" label="id数量">
            <template slot-scope="scope">
              {{ scope.row.children ? scope.row.children.length : "" }}
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <ul class="tag_box">
                <!-- id列表 -->
                <li
                  v-for="(child, index) in scope.row.children"
                  :key="child.id"
                >
                  <el-tag :disable-transitions="false">
                    <span>{{ child.siteName }}</span>
                    <div class="icon_box">
                      <i
                        class="el-icon-edit icon"
                        @click="handleEdit(index, child, 'child', scope.$index)"
                      />
                      <el-popconfirm
                        :hideIcon="true"
                        title="确定删除吗？"
                        @confirm="delId(index, child, 'child', scope.$index)"
                      >
                        <i class="el-icon-delete icon" slot="reference" />
                      </el-popconfirm>
                    </div>
                  </el-tag>
                </li>
                <li>
                  <!-- 添加 -->
                  <el-button
                    class="button-new-tag"
                    size="small"
                    @click="
                      addId(
                        'child',
                        scope.row.id,
                        scope.row.siteType,
                        scope.$index
                      )
                    "
                  >
                    添加</el-button
                  >
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column align="right" label="操作">
            <template slot-scope="scope">
              <!-- 移动 -->
              <el-tooltip
                effect="dark"
                content="移动到某个父级"
                placement="top"
                v-if="scope.row.children && scope.row.children.length == 0"
              >
                <el-button
                  class="icon_btn"
                  icon="el-icon-top"
                  circle
                  size="mini"
                  @click="moveId(scope.row)"
                ></el-button>
              </el-tooltip>
              <!-- 编辑 -->
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row, 'menu', 0)"
                >编辑</el-button
              >
              <!-- 删除 -->
              <template>
                <el-popconfirm
                  :hideIcon="true"
                  title="确定删除吗？"
                  @confirm="delId(scope.$index, scope.row, 'menu', 0)"
                >
                  <el-button
                    slot="reference"
                    size="mini"
                    type="danger"
                    :disabled="
                      scope.row.children && scope.row.children.length != 0
                    "
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <Pagination
        :total="total"
        :list="tableData"
        :page="page"
        :pageSize="pageSize"
        @change="changePage"
      />

      <!-- 添加/编辑 -->
      <el-dialog
        :title="title"
        :top="dialog_top"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        @close="cancel"
      >
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <!-- id类型 -->
          <el-form-item
            :label="openType == 'child' ? 'id类型' : '父级类型'"
            prop="siteType"
          >
            <el-radio
              v-model="ruleForm.siteType"
              label="0"
              :disabled="openType == 'child'"
              >taskID</el-radio
            >
            <el-radio
              v-model="ruleForm.siteType"
              label="1"
              :disabled="openType == 'child'"
              >siteID</el-radio
            >
          </el-form-item>
          <!-- 父级id -->
          <el-form-item label="父级id" prop="parentId" v-if="false">
            <el-input
              v-model="ruleForm.parentId"
              :disabled="openType == 'child' || !is_add"
              placeholder="请输入父级id"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 名称 -->
          <el-form-item label="名称" prop="siteName">
            <el-input
              v-model="ruleForm.siteName"
              placeholder="请输入名称"
              clearable
            ></el-input>
          </el-form-item>
          <!-- id -->
          <el-form-item
            :label="ruleForm.siteType == 0 ? 'taskID' : 'siteID'"
            prop="siteId"
            v-if="openType == 'child'"
          >
            <el-input
              v-model="ruleForm.siteId"
              :placeholder="
                ruleForm.siteType == 0 ? '请输入taskID' : '请输入siteID'
              "
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="submitForm"
            >{{ is_add ? "确 定" : "保 存" }}</el-button
          >
        </div>
      </el-dialog>

      <!-- 父级选择 -->
      <el-dialog
        title="选择父级"
        :top="dialog_top"
        :close-on-click-modal="false"
        :visible.sync="menuVisible"
        @close="menuVisible = false"
      >
        <el-form
          :model="menuForm"
          :rules="rules"
          ref="menuForm"
          v-load="menuLoading"
        >
          <el-form-item label="选择移动到的父级" prop="menuVal">
            <el-select
              v-model="menuForm.menuVal"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in menuList"
                :key="item.id"
                :label="item.siteName"
                :value="item.id"
                :disabled="item.isCheck"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="menuVisible = false">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="selectMenu"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
import mixins from "../../../mixins";

export default {
  mixins: [mixins],
  data() {
    return {
      btnLoading: false,
      siteName: "",
      siteId: "",
      siteType: "",
      title: "添加父级",

      dialogFormVisible: false,
      is_add: true,
      // 表单
      ruleForm: {
        siteName: "",
        siteId: "",
        siteType: "0",
        parentId: ""
      },
      // 表单检验规则
      rules: {
        parentId: [
          { required: true, message: "请输入父级id", trigger: "blur" }
        ],
        siteName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        siteId: [{ required: true, message: "请输入id", trigger: "blur" }],
        siteType: [
          { required: true, message: "请选择id类型", trigger: "blur" }
        ],
        menuVal: [{ required: true, message: "请选择", trigger: "blur" }]
      },
      row_index: 0,
      listIndex: 0,
      row_id: "",
      row_item: {},
      dialog_top: "15vh",

      menuVisible: false,
      menuLoading: false,
      openType: "",
      menuList: [],
      menuForm: {
        menuVal: ""
      }
    };
  },
  watch: {
    is_add(val) {
      if (val) {
        this.openType == "menu" ? (this.title = "添加父级") : "添加id";
      } else {
        this.openType == "menu" ? (this.title = "编辑父级") : "编辑id";
      }
    },
    openType(val) {
      if (val == "menu") {
        this.is_add ? (this.title = "添加父级") : "编辑父级";
      } else {
        this.is_add ? (this.title = "添加id") : "编辑id";
      }
    }
  },
  mounted() {},
  methods: {
    // 获取列表数据
    getList() {
      if (!this.authority) return;
      this.loading = true;
      this.tableScrollTop();
      this.$http({
        url: this.$api.idPage_list,
        data: {
          siteName: this.siteName,
          siteId: this.siteId,
          siteType: this.siteType,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = [];
          res.data.concent.forEach(val => {
            if (val.children == null) val.children = [];
            this.tableData.push(val);
          });
        } else {
          this.total = 0;
          this.tableData = [];
          this.$hint(res.message, "err");
        }
      });
    },
    // 获取所有taskID/siteID
    getAllID(siteType) {
      this.menuLoading = true;
      this.$http({
        url: this.$api.id_list,
        data: { siteType }
      })
        .then(res => {
          this.menuLoading = false;
          if (res.code == 0) {
            if (siteType == 0) {
              this.menuList = res.data.taskId;
            } else {
              this.menuList = res.data.siteId;
            }
            this.menuList.forEach(val => {
              val.isCheck = false;
              if (val.id == this.row_id) val.isCheck = true;
            });
          }
        })
        .catch(err => {
          this.menuLoading = false;
        });
    },
    // 新增、编辑
    editID() {
      this.btnLoading = true;
      let data = JSON.parse(JSON.stringify(this.ruleForm));
      this.$http({
        url: this.$api.edit_id,
        data
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          if (this.openType != "move") {
            if (this.is_add) {
              if (this.openType == "child") {
                if (this.tableData[this.row_index].children == null)
                  this.tableData[this.row_index].children = [];
                this.tableData[this.row_index].children.unshift(res.data);
              } else {
                this.page = 1;
                this.getList();
              }
              this.$hint("添加成功");
            } else {
              if (this.openType == "child") {
                this.tableData[this.listIndex].children[
                  this.row_index
                ].siteName = this.ruleForm.siteName;
                this.tableData[this.listIndex].children[
                  this.row_index
                ].siteId = this.ruleForm.siteId;
                this.tableData[this.listIndex].children[
                  this.row_index
                ].siteType = this.ruleForm.siteType;
              } else {
                this.tableData[
                  this.row_index
                ].siteName = this.ruleForm.siteName;
                this.tableData[
                  this.row_index
                ].siteType = this.ruleForm.siteType;
              }
              this.$hint("编辑成功");
            }
            this.cancel();
          } else {
            this.menuVisible = false;
            this.getList();
            this.$hint("移动成功");
          }
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 删除id
    delId(index, row, type, i) {
      this.$http({
        url: this.$api.del_id,
        data: { id: row.id }
      }).then(res => {
        if (res.code == 0) {
          if (type == "menu") {
            this.tableData.splice(index, 1);
            this.total--;
          } else {
            this.tableData[i].children.splice(index, 1);
          }
          this.$hint("删除成功");
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 点击增加id
    addId(openType, parentId, siteType, index) {
      this.openType = openType;
      this.row_index = index;
      this.dialogFormVisible = true;
      this.is_add = true;
      this.ruleForm = {
        siteName: "",
        siteId: "",
        siteType: String(siteType),
        parentId
      };
      if (openType == "menu")
        this.ruleForm.siteId = Math.ceil(Math.random() * 10000);
    },
    // 点击编辑id
    handleEdit(index, row, openType, listIndex) {
      this.openType = openType;
      this.dialogFormVisible = true;
      this.is_add = false;
      this.row_index = index;
      this.listIndex = listIndex;
      this.ruleForm = {
        siteName: row.siteName,
        siteId: row.siteId,
        id: row.id,
        siteType: String(row.siteType),
        parentId: row.parentId
      };
    },
    // 确定新增、编辑
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) this.editID();
      });
    },
    // 点击取消
    cancel() {
      this.dialogFormVisible = false;
      this.ruleForm = {
        siteName: "",
        siteId: "",
        siteType: "0"
      };
      this.$refs.ruleForm.resetFields();
    },
    // 筛选ID类型
    selectType(e) {
      this.siteType = e;
      this.search();
    },
    // 搜索
    search() {
      this.page = 1;
      this.getList();
    },
    // 移动到某个父级
    moveId(row) {
      this.openType = "move";
      this.row_id = row.id;
      this.row_item = row;
      this.menuForm.menuVal = "";
      this.getAllID(row.siteType);
      this.menuVisible = true;
    },
    // 保存选择的父级
    selectMenu() {
      this.$refs.menuForm.validate(valid => {
        if (valid) {
          this.ruleForm = {
            siteName: this.row_item.siteName,
            siteId: this.row_item.siteId,
            id: this.row_item.id,
            siteType: String(this.row_item.siteType),
            parentId: this.menuForm.menuVal
          };
          this.editID();
        }
      });
    }
  }
};
</script>

<style></style>
<style lang="less" scoped>
.tag_box {
  display: flex;
  flex-wrap: wrap;
  .icon_box {
    margin-left: 5px;
    .icon {
      margin-left: 5px;
      cursor: pointer;
    }
  }
}
.icon_btn {
  transform: rotate(45deg);
  transition: all 0.5s;
  &:hover {
    transform: rotate(0deg);
  }
}

.card_box {
  display: flex;
  .card {
    flex: 1;
    margin-right: 20px;
    color: #525f7f;
    &:nth-last-child(1) {
      margin-right: 0px;
    }
    .clearfix {
      position: relative;
      font-weight: bold;
      .icon {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-weight: bold;
        cursor: pointer;
      }
    }

    .li_item {
      width: 100%;
      // min-height: 50px;
      // display: block;
      > li {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        font-size: 13px;
        .icon {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/idManage.vue